(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracServiceDeleteController',NasracServiceDeleteController);

    NasracServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracService'];

    function NasracServiceDeleteController($uibModalInstance, entity, NasracService) {
        var vm = this;

        vm.nasracService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NasracService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
